/** Full-screen loading overlay with a progress bar (model loading for the toon renderer). */
import { el } from './dom';

export interface LoadingScreen {
  set(done: number, total: number, label: string): void;
  close(): void;
}

export function showLoading(parent: HTMLElement, title = 'Loading the dungeon'): LoadingScreen {
  const root = el('div', 'screen loading', parent);
  const box = el('div', 'screen-box loading-box', root);
  el('h2', '', box, title);
  const bar = el('div', 'loading-bar', box);
  const fill = el('div', 'loading-fill', bar);
  const text = el('div', 'loading-text', box, 'Starting…');
  root.setAttribute('role', 'status');
  return {
    set(done, total, label) {
      const pct = total > 0 ? Math.round((done / total) * 100) : 0;
      fill.style.width = `${pct}%`;
      text.textContent = `${label} · ${done} / ${total}`;
    },
    close() {
      root.remove();
    },
  };
}
